<template>
  <div class="d-flex flex-column justify-space-between" style="height: 100%; ">
    <div>
      <p
        class="caption red--text"
      >*Đơn Hàng này chưa có học viên. Bạn có muốn tạo hoặc link đến học viên đã có sẵn</p>
      <div class="d-flex">
        <autocomplete-student
          v-model="student"
          :defaultStudent="lead.student"
          class="mr-2"
          placeholder="Tìm kiếm học sinh"
          label="Học Sinh"
          dense
          return-object
          @change="updateStudent"
        />
        <p class="caption ma-3">Hoặc</p>
        <v-btn outlined color="primary" @click.stop="dialog=!dialog">
          <v-icon>mdi-account-multiple-plus</v-icon>Tạo Mới
        </v-btn>
      </div>
      <div>
        <p>Tên: {{student.name}}</p>
        <p>Mã: {{student.code}}</p>
      </div>
    </div>
    <div class="d-flex">
      <v-spacer />
      <v-btn
        color="primary"
        @click="save()"
        :disabled="!student.id"
        :loading="loading"
      >Lưu & Tiếp Tục</v-btn>
    </div>
    <student-new-dialog :state="dialog" @done="updateStudent" />
  </div>
</template>
<script>
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import StudentNewDialog from '@/modules/student/StudentNewDialog'
import { get } from 'lodash'
import { mapActions } from 'vuex'
export default {
  components: { AutocompleteStudent, StudentNewDialog },
  props: {
    lead: Object
  },
  created () {
    this.student = get(this.lead, 'student', {})
  },
  data () {
    return {
      dialog: false,
      student: {},
      loading: false
    }
  },
  computed: {},
  methods: {
    ...mapActions('leads', [
      'updateLead'
    ]),
    updateStudent (student) {
      this.student = student
      this.$emit('update:student', student)
    },
    async save () {
      if (this.student.id) {
        this.loading = true
        await this.updateLead({ id: this.lead.id,
          student: this.student.id,
          customerName: this.lead.customerName || this.student.name
        })
        this.loading = false
        this.$alert.success(`Cập nhật thành công học viên: ${this.student.name} liên kết với hóa đơn`)
        this.$emit('complete')
      }
    }
  },
  filters: {},
  watch: {
    lead () {
      this.student = get(this.lead, 'student', {})
    }
  }
}
</script>
